import axiosTouri from "../../axiosTuri";

// Get All Hotel Reservation
export const getAllHotelResrtvation = async () => {
  const res = await axiosTouri.get(`hotel-reservations`);
  if (res.data.status == "success") {
    return res.data;
  }
};
